// @flow
import styled from "styled-components";
import { Td } from "../../components/TableX";

export const TdYourTeam = styled(Td)`
	display: table-cell;
	padding: 5px;
	> div {
		display: flex;
		align-items: center;
	}
`;

export default TdYourTeam;


// WEBPACK FOOTER //
// ./src/components/Draft/TdYourTeam.js